<template>
    <div>
        <div id="colorDropdown" class="dropdown" :class="showDropdown ? 'show' : ''">
        <span id="colorButton" class="form-control" :class="sizeClass" title="Pick a color"
              @click="showDropdown = !showDropdown"
              data-bs-toggle="dropdown">
            <span class="form-control" :class="insideColorClass" :style="{'background-color': color}">&nbsp;</span>
        </span>
            <ul class="dropdown-menu color-palette" :class="showDropdown ? 'show' : ''" ref="palette" id="colorMenu"
                :style="shiftLeft ? 'left: -350px !important;' : ''">
                <li class="color-holder">
                    <div class="color-box-sm" :style="{'background-color': c}" v-for="c in colors"
                         @click="onColorClick(c)">
                        <i class="fa fa-check" style="position: absolute" v-show="c === color"
                           :class="getSelectedClass(color)"></i>
                    </div>

                    <div class="me-1">
                        <input type="text" class="form-control color-text" v-model.trim="color" maxlength="7"
                               placeholder="Color value"
                               @keyup.enter.esc="$refs.palette.classList.remove('show'); onClose()"/>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ColorPicker',
    props: {
        // 'modelValue': {type: String, default: '#FFFFFF'},
        colorObject: {type: Object},
        colorField: {type: String},
        'colors': {
            type: Array,
            default: () => webase.utils.color.availableColors()
        },

        drop: {type: String, default: 'dropdown'},
        shiftLeft: {type: Boolean, default: false},
        sizeClass: {type: String, default: 'color-box'},
    },
    emits: ['colorSelected'],
    computed: {
        insideColorClass() {
            return this.sizeClass + '-inside'
        },
        initialColorValue() {
            return this.colorObject[this.colorField]
        }
    },
    data() {
        return {
            color: this.initialColorValue || '#FFFFFF',
            showDropdown: false,
        }
    },
    watch: {
        color(v) {
            if (!/^#/.test(v)) {
                this.$nextTick(() => this.color = '#' + this.color);
            }

            this.colorObject[this.colorField] = v
        }
    },
    mounted() {
        this.color = this.colorObject[this.colorField]
    },
    methods: {
        onClose() {
            this.showDropdown = false
        },

        onColorClick(color) {
            this.color = color
            this.$emit('colorSelected', color);
            this.showDropdown = false
            this.colorObject[this.colorField] = this.color
        },

        getSelectedClass(color) {
            let lightOrDark = webase.utils.ui.getOppositeColor(color)
            return `text-${lightOrDark}`
        }
    }
}
</script>
